import { create } from "zustand";
import { persist, devtools } from "zustand/middleware";

import { IConfigStore } from "./interface";
import { constantConfigMaintenance } from "./constant";

const configStore = create<IConfigStore>()(
  devtools(
    persist(
      (set) => ({
        config: {
          enableFillVendor: {
            isEnable: false,
          },
        },
        lockVendor: false,
        setConfig: (e) =>
          set((state: IConfigStore) => ({ ...state, config: e })),
        setLockVendor: (e) =>
          set((state: IConfigStore) => ({ ...state, lockVendor: e })),
        configMaintenance: constantConfigMaintenance,
        setConfigMaintenance: (e) =>
          set((state: IConfigStore) => ({
            ...state,
            configMaintenance: e,
          })),
      }),
      { name: "qovis-oversea-config" }
    )
  )
);

export default configStore;
